import { render } from "./radioBoxGroupField.vue?vue&type=template&id=858f7e4a"
import script from "./radioBoxGroupField.vue?vue&type=script&lang=js"
export * from "./radioBoxGroupField.vue?vue&type=script&lang=js"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__